import type { TFunction } from 'i18next';
import { headingStyle } from './surveyLogic';

interface Props {
  outro: string;
  /** True when the guest comes back to an already-answered survey. */
  offerAgain: boolean;
  onAgain: () => void;
  t: TFunction;
  lang: string;
}

export default function SurveyDone({ outro, offerAgain, onAgain, t, lang }: Props) {
  return (
    <section className="flex flex-col items-center text-center gap-4 pt-10">
      <h1 className="font-display text-3xl text-ink" style={headingStyle(lang)}>{t('survey.thanks')}</h1>
      {outro && <p className="font-mono text-base text-ink whitespace-pre-line">{outro}</p>}
      <p className="font-mono text-sm text-ink-mute">{t('survey.thanksBody')}</p>
      {offerAgain && (
        <button
          type="button"
          onClick={onAgain}
          className="mt-4 min-h-[48px] border-2 border-solid border-ink rounded-btn bg-paper px-6 font-display text-lg text-ink"
        >
          {t('survey.again')}
        </button>
      )}
    </section>
  );
}
